// extracted by mini-css-extract-plugin
export default {"container":"Focus_container__bi41G","focus":"Focus_focus__FezSv","files":"Focus_files__14hEn"};